import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import CenterOnAddressInput from "../../views/CenterOnAddressInput.js";
const {
  t,
  tf
} = I18N.ns('molten.imagine.map.centerOnAddress');
export default {
  type: 'map.centerOnAddress',
  name: tf('name'),
  matches: {
    use: 'contextMenu',
    client: ['GoogleMapsRolloverSelectionPointer', 'MapBoxRolloverSelectionPointer']
  },
  // handles clicks on unoccupied map space
  handles: context => context.mapViewer && !Context.getTargets(context).length,
  appearance: () => ({
    name: t('name')
  }),
  perform: ({
    context
  }) => {
    const mapName = context?.mapViewer?.mapOptions?.mapName || 'map';
    Dialogs.show({
      component: CenterOnAddressInput.Dialog,
      props: {
        mapName
      }
    });
  }
};